/**
 * Elenco numerato dei passi guidati, con la spunta sui passi fatti e il
 * pulsante principale sul primo da fare. Lo usano il cruscotto della squadra
 * senza rosa (V06) e la scelta del contesto della societa nuova (V05).
 */

import { Link } from 'react-router-dom';
import { CheckIcon } from 'lucide-react';
import { Button } from '@/components/ui/button';

export interface Passo {
  chiave: string;
  titolo: string;
  testo: string;
  fatto: boolean;
  prossimo: boolean;
  azioni: { etichetta: string; a: string }[];
}

export function ElencoPassi({ passi }: { passi: Passo[] }) {
  return (
    <ol className="border-t border-border">
      {passi.map(({ chiave, titolo, testo, fatto, prossimo, azioni }, i) => (
        <li
          key={chiave}
          className="grid grid-cols-[auto_1fr] gap-x-3 border-b border-border px-1 py-3"
        >
          <span
            className={`flex size-7 items-center justify-center rounded-full text-sm font-semibold tabular-nums ${
              fatto ? 'bg-foreground text-background' : 'border border-border'
            }`}
            aria-label={fatto ? 'Fatto' : `Passo ${i + 1}`}
          >
            {fatto ? <CheckIcon className="size-4" /> : i + 1}
          </span>
          <span className="flex min-w-0 flex-col gap-1">
            <span className="font-semibold">
              {titolo}
              {fatto && <span className="font-normal text-muted-foreground"> · fatto</span>}
            </span>
            <span className="text-sm text-muted-foreground">{testo}</span>
            <span className="mt-1 flex flex-wrap gap-2">
              {azioni.map((azione, j) => (
                <Button
                  key={azione.a}
                  asChild
                  size="sm"
                  variant={prossimo && j === 0 ? 'default' : 'outline'}
                >
                  <Link to={azione.a}>{azione.etichetta}</Link>
                </Button>
              ))}
            </span>
          </span>
        </li>
      ))}
    </ol>
  );
}
